export interface AccentColorPreset {
  id: string;
  name: string;
  accent500: string;
  accent600: string;
  accent100: string;
  previewBg: string;
}

export const ACCENT_COLOR_PRESETS: AccentColorPreset[] = [
  { id: 'teal', name: 'Turkuaz', accent500: '#14B8A6', accent600: '#0D9488', accent100: '#CCFBF1', previewBg: 'bg-[#14B8A6]' },
  { id: 'orange', name: 'Bitmiyo Turuncusu', accent500: '#F2803D', accent600: '#D96A2A', accent100: '#FDE8D9', previewBg: 'bg-[#F2803D]' },
  { id: 'blue', name: 'Okyanus Mavisi', accent500: '#3B82F6', accent600: '#2563EB', accent100: '#DBEAFE', previewBg: 'bg-[#3B82F6]' },
  { id: 'indigo', name: 'Derin İndigo', accent500: '#6366F1', accent600: '#4F46E5', accent100: '#E0E7FF', previewBg: 'bg-[#6366F1]' },
  { id: 'purple', name: 'Zarif Mor', accent500: '#8B5CF6', accent600: '#7C3AED', accent100: '#EDE9FE', previewBg: 'bg-[#8B5CF6]' },
  { id: 'emerald', name: 'Zümrüt Yeşili', accent500: '#10B981', accent600: '#059669', accent100: '#D1FAE5', previewBg: 'bg-[#10B981]' },
  { id: 'rose', name: 'Gül Kırmızısı', accent500: '#F43F5E', accent600: '#E11D48', accent100: '#FFE4E6', previewBg: 'bg-[#F43F5E]' },
  { id: 'amber', name: 'Sıcak Amber', accent500: '#F59E0B', accent600: '#D97706', accent100: '#FEF3C7', previewBg: 'bg-[#F59E0B]' },
];

export const applyAccentColor = (colorId: string = 'teal') => {
  const preset = ACCENT_COLOR_PRESETS.find(p => p.id === colorId) || ACCENT_COLOR_PRESETS[0];
  const root = document.documentElement;
  root.style.setProperty('--accent-500', preset.accent500);
  root.style.setProperty('--accent-600', preset.accent600);
  root.style.setProperty('--accent-100', preset.accent100);
};
